import { useQuery } from "@apollo/client";
import cn from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useState } from "react";

import { GET_ALL_PAGES_USER } from "@api/queriesV2/cms";
import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import { getPageFolderName, getPageTypes } from "@config/cms";
import { useStore } from "@hooks/useZustandProvider";
import i from "@styles/icons.module.scss";
import Container from "@ui-kit/Container/Container";
import Loading from "@ui-kit/Loading/Loading";
import { localizedDate } from "@utils/utils";

import s from "./LatestBlock.module.scss";

const LatestBlock = ({ settings, data, updateField }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { getBlockLocale } = useStore();
  const { title } = data;
  const { blockType } = settings.common;
  const { contentType } = settings.specific;
  const [pagesList, setPagesList] = useState([]);

  const lang = getBlockLocale(locale);

  const { loading } = useQuery(GET_ALL_PAGES_USER, {
    context: { clientName: "v2" },
    fetchPolicy: "cache-and-network",
    variables: {
      language: lang,
      type: getPageTypes()[contentType.value],
    },
    onCompleted: (data) => {
      if (data.getAllPagesUser.length) {
        setPagesList(data.getAllPagesUser);
      } else {
        setPagesList([]);
      }
    },
  });

  const pages = pagesList.filter((i) => !!i.data);

  const first = pages[0];

  const other = pages.slice(-4);

  return (
    <Container className={s.latest}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          {loading ? (
            <Loading />
          ) : pagesList?.length ? (
            <div className={s.content}>
              <div className={cn(s.block, s.last)}>
                <div className={s.news}>
                  <time dateTime={first.properties?.datePublished}>
                    {localizedDate(
                      first.properties?.datePublished,
                      "dd MMMM yyyy",
                      locale,
                    )}
                  </time>
                  <Link
                    href={`/${getPageFolderName()[contentType.value]}/${first.data.slug}`}
                  >
                    <h3>{first.data.title}</h3>
                  </Link>
                </div>
              </div>
              <div className={cn(s.block, s.other)}>
                {other.map((article, key) => {
                  return (
                    <div key={key} className={cn(s.news, s.lastNews)}>
                      <time
                        dateTime={localizedDate(
                          article.properties.datePublished,
                          "dd-MM-yyyy hh:mm",
                          locale,
                        )}
                      >
                        {localizedDate(
                          article.properties.datePublished,
                          "dd MMMM yyyy",
                          locale,
                        )}
                      </time>
                      <Link
                        href={`/${getPageFolderName()[contentType.value]}/${article.data.slug}`}
                      >
                        <h4>{article.data.title}</h4>
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div>No news yet.</div>
          )}
          <div className={s.showMore}>
            <Link href="/blog" className={s.showMoreLink}>
              {t("show more")}
              <icon className={i.arrowRight_v2} />
            </Link>
          </div>
        </section>
      </Container>
    </Container>
  );
};

export default LatestBlock;
